const icons = {
	PLUGINS_CHAT: '/assets/plugins/plugin-chat.png',
	PLUGINS_FRESHDESK: '/assets/plugins/plugin-freshdesk.png',
	PLUGINS_SMS: '/assets/plugins/plugin-sms.png',
	PLUGINS_VERIFICATION: '/assets/plugins/plugin-verification.png',
	SETTINGS_ICON: '/assets/images/settings-icon.png',
	DIY_ICON: '/assets/images/diy-icon.svg',
	DIY_FIRE_MAN_ICON: '/assets/images/diy-boost-man-on-fire.svg',
	CLOUD_PLAN_BASIC: '/assets/images/cloud-plan-basic.svg',
	CLOUD_PLAN_FIAT_RAMP: '/assets/images/cloud-plan-fiat-ramp.svg',
	CLOUD_PLAN_CRYPTO_PRO: '/assets/images/cloud-plan-crypto-pro.svg',
	CLOUD_PLAN_CRYPTO_PRO_FIAT_RAMP: '/assets/images/stacked-pro-on-fiat.svg',
	PLUGINS_ZENDESK: '/assets/plugins/plugin-zendesk.png',
	PLUGINS_BANK: '/assets/plugins/plugin-bank.png',
	PLUGINS_VAULT: '/assets/plugins/plugin-vault.png',
	DEFAULT_PLUGINS: '/assets/plugins/default-plugin.png',
	HOLLAEX_INIT_LOGO: '/assets/images/hollaex-icon-01.svg',
	CANDLES_LOGO: '/assets/images/Light-theme-candles.svg',
	P2P_FEATURE: '/assets/images/p2p-feature-admin.svg',
	SET_ADMIN_NETWORK_KEYS: '/assets/images/set-admin-network-keys.svg',
	SET_ADMIN_EMAIL: '/assets/images/set-admin-email.svg',
	REFERRAL_ICON: '/assets/images/referrals-icon.svg',
	SET_ADMIN_PASSWORD: '/assets/images/set-admin-password.svg',
	MAX_ICON: '/assets/images/maxIcon.svg',
	SET_ADMIN_RETYPE_PASSWORD: '/assets/images/set-admin-retype-password.svg',
	TIMEZONE_WORLD_MAP: '/assets/images/timezone-worldmap.svg',
	SETUP_SECTION_PRO_TRADING: '/assets/images/setup-section-pro-trading-01.svg',
	SETUP_SECTION_LOADING: '/assets/images/762.gif',
	SETUP_SECTION_BACKOFFICE: '/assets/images/setup-section-backoffice.svg',
	SETUP_SECTION_LIQUIDITY: '/assets/images/setup-section-liquidity.svg',
	SETUP_SECTION_QUICK_TRADE: '/assets/images/setup-section-quick-trade.svg',
	SETUP_SECTION_CRYPTO_WALLET: '/assets/images/setup-section-crypto-wallet.svg',
	USER_SECTION_WALLET: '/assets/images/admin-user-wallet.svg',
	DUST_CONVERTER: '/assets/images/duster-wallet-sweeper.svg',
	SETUP_SECTION_PRICE_DISCOVERY: '/assets/images/setup-price-discovery.svg',
	SETUP_QUICK_TRADE: '/assets/images/initialize-quick-trade.svg',
	HEX_PATTERN_ICON: '/assets/icons/hex-pattern-icon-05.svg',
	GENERAL_SETUP: '/assets/images/general-setup.svg',
	USERS_SETUP: '/assets/images/users.svg',
	BLUE_SCREEN_EYE_ICON: '/assets/images/all-seeing-eye-admin-role-blue.png',
	BLUE_SCREEN_COMMUNICATON_SUPPORT_ROLE:
		'/assets/images/communications-role-seal-02.svg',
	BLUE_SCREEN_EXCHANGE_SUPPORT_ROLE:
		'/assets/images/exchange-support-role-01.svg',
	BLUE_SCREEN_SUPERVISOR: '/assets/images/supervisor.svg',
	BLUE_SCREEN_KYC: '/assets/images/KYC-01.svg',
	BLUE_SCREEN_LINK: '/assets/images/link.svg',
	USER_DETAILS_ICON: '/assets/images/user-info-details-page.svg',
	TWO_STEP_KEY_ICON: '/assets/images/2fa-01.svg',
	ACC_FREEZE: '/assets/images/freeze.svg',
	ACC_FLAG: '/assets/images/flag.svg',
	ADMIN_PLUGINS: '/assets/images/plugins.svg',
	ADMIN_TIERS: '/assets/images/tiers.svg',
	ADMIN_ROLES: '/assets/images/roles.svg',
	META_MASK_NOT_FOUND: '/assets/icons/metamask-fox-stake-not-detected.svg',
	ADMIN_CUSTOMIZE: '/assets/images/customize.svg',
	ADMIN_MISSING_GO_BACK: '/assets/images/missing-page-go-back-to-dash.svg',
	HELP_DESCRIPTION_POPUP: '/assets/images/help-popup-description.png',
	HELP_FOOTER_POPUP:
		'/assets/images/terms_of_service_and_privacy_policy-tooltip.png',
	HELP_REFERRAL_BADGE_POPUP: '/assets/images/help-popup-footer.png',
	REFRESH: '/assets/icons/refresh-icon.svg',
	DEPOSIT_TIERS_SECTION: '/assets/images/deposit-tier-section.svg',
	WITHDRAW_TIERS_SECTION: '/assets/images/withdraw-tier-section.svg',
	TAKER_TIERS_SECTION: '/assets/images/taker-tier-section.svg',
	NO_ACTIVE_ORDERS: '/assets/images/no-active-orders-01.svg',
	NO_ACTIVE_TRADES: '/assets/images/no-recent-trades-01.svg',
	NO_ACTIVE_DEPOSITS: '/assets/images/no-recent-deposits.svg',
	NO_ACTIVE_WITHDRAWALS: '/assets/images/no-recent-withdrawals.svg',
	MAKER_TIERS_SECTION: '/assets/images/maker-tier-section.svg',
	LIMITS_SECTION_ICON: '/assets/images/limits-coin-tiers.svg',
	FEES_SECTION_ICON: '/assets/images/limits-pairs-tiers.svg',
	EDIT_STRING: '/assets/icons/edit-string.svg',
	OPERATOR_EDIT_ICON: '/assets/icons/upload-graphic-edit.svg',
	EDIT_ICON: '/assets/images/edit-icon.svg',
	EDIT_SECTION: '/assets/images/gear-homepage-edit-sections-01.svg',
	EDIT_BACKGROUND: '/assets/images/upload-01.svg',
	SEARCH: '/assets/images/search.svg',
	BLACK_CHECK: '/assets/acounts/account-icons-19.svg',
	RED_WARNING: '/assets/acounts/account-icons-09.svg',
	PLUGIN_IMAGE: '/assets/images/plugin-board-page.svg',
	DEFAULT_PLUGIN_THUMBNAIL: '/assets/images/default-plugin-thumbnail.png',
	DEFAULT_PLUGIN_PREVIEW: '/assets/images/default-plugin-preview-image.png',
	ADD_THIRD_PARTY_PLUGIN: `/assets/images/add-third-party-plugin-black-01.svg`,
	PLUGIN_REMOVAL_WHITE: `/assets/images/plugin-removal-white-01.svg`,
	CHAT_EMOJI: '/assets/icons/emoji-face-icon.svg',
	CANCEL_CROSS_ACTIVE: '/assets/images/cancel-cross-active.svg',
	VERIFICATION_ICON: '/assets/images/verification-green-tick.svg',
	CHAT_FEATURE_ICON: '/assets/images/chat-feature-icon.svg',
	APPS_FEATURE_ICON: '/assets/images/apps.svg',
	HOME_PAGE_FEATURE_ICON: '/assets/images/home-page.svg',
	USER_EMAIL: '/assets/images/user-email.svg',
	USER_EMAIL_VERIFIED: '/assets/images/user-email-verified.svg',
	USER_EMAIL_UNVERIFIED: '/assets/images/user-email-unverified.svg',
	SPINNER: '/assets/images/spinner.gif',

	// Notification Icons
	VERIFICATION_PENDING: '/assets/images/verification-pending-orange.svg',
	VERIFICATION_REJECTED:
		'/assets/images/verification-rejected-yellow-cross.svg',
	VERIFICATION_INCOMPLETE: '/assets/images/verification-attention-red.svg',
	VERIFICATION_VERIFIED: '/assets/images/verification-green-tick.svg',
	CLOUD_ICON: '/assets/images/current-plan-cloud-icon.svg',
	QUICK_TRADE: '/assets/images/quick-trade-01.svg',
	PAPER_CLIP: '/assets/acounts/paperclip-attach-01.svg',
	COIN_ICONS: {
		ada: '/assets/images/ada-icon.svg',
		bch: '/assets/images/bch-icon.svg',
		eth: '/assets/images/eth-icon.svg',
		btc: '/assets/images/btc-icon.svg',
		bnb: '/assets/images/bnb-icon.svg',
		dai: '/assets/images/dai-icon.svg',
		eos: '/assets/images/eos-icon.svg',
		ltc: '/assets/images/ltc-icon.svg',
		trx: '/assets/images/trx-icon.svg',
		tusd: '/assets/images/tusd-icon.svg',
		xlm: '/assets/images/xlm-icon.svg',
		xmr: '/assets/images/xmr-icon.svg',
		xrp: '/assets/images/xrp-icon.svg',
	},
	MISSING_ICON: '/assets/images/missing-coin.svg',
	SETTINGS: '/assets/images/noun_settings.svg',
	CURRENCY_SYMBOL: '/assets/images/noun_currency.svg',
	BLOCKCHAIN_BACKGROUND: '/assets/images/blockchain-background.svg',
	FIAT_BACKGROUND: '/assets/images/fiat-background.svg',
	RESTART_CIRCLE_ICON: '/assets/images/restart-circle.svg',
	STAKE_FEATURE: '/assets/images/stake-feature.svg',
	ULTIMATE_FIAT_FEATURE: '/assets/images/stake-feature.svg',
	RESOURCE_PLUGIN: '/assets/images/plugins.png',
	RESOURCE_FAQ: '/assets/images/help-faq.png',
	RESOURCE_VIDEOS: '/assets/images/videos.png',
	RESOURCE_PRO_EXCHANGE: '/assets/images/HollaEx-pro-exchange.png',
	RESOURCE_OTHER_RESOURCES: '/assets/images/resources.png',
	RESOURCE_STATUS: '/assets/images/status-page-hollaex.png',
	RESOURCE_ARTICLES: '/assets/images/hollaex-blogs-articles.png',
	RESOURCE_EXPLORER: '/assets/images/hollaex-network-explorer.png',
	EDIT_PENCIL_ICON: '/assets/images/edit-pencil.svg',
	SEND_ARROW_ICON: '/assets/images/send-arrow.svg',
	PENDING_ORANGE_GEAR: '/assets/images/pending-orange-gear.svg',
	BROKER_DESK_ICON: '/assets/images/broker-desk-otc-deal.svg',
	TOOLTIP: '/assets/icons/question-circle-solid.svg',
	CARD_SECTION_ICON_1: '/assets/images/Group_93.svg',
	CARD_SECTION_ICON_2: '/assets/images/Group_95.svg',
	CARD_SECTION_ICON_3: '/assets/images/Group_96.svg',
	CARD_SECTION_ICON_4: '/assets/images/Group_97.svg',
	KYC_PLUGIN_ICON: '/assets/images/kyc-plugin-icon.svg',
	KYC_USER_ICON: '/assets/images/kyc-user-icon.svg',
	FIAT_ONRAMP_TOOLTIP: '/assets/images/on-ramp-hover-tool-tip.png',
	FIAT_OFFRAMP_TOOLTIP: '/assets/images/off-ramp-help-hover-tool-tip.png',
	FIAT_PAYMENT_TOOLTIP:
		'/assets/images/payment-account-help-hover-tool-tip.png',
	BANK_FIAT_PILLARS: '/assets/images/bank-fiat-pillers.svg',
	PAYPAL_FIAT_ICON: '/assets/images/paypal-fiat-page.svg',
	ONRAMP_DOLLAR_ICON: '/assets/images/on-ramp-dollar-fiat-slant-left.svg',
	OFFRAMP_DOLLAR_ICON: '/assets/images/off-ramp-dollar-fiat-slant-right.svg',
	DOUBLEFIAT_ICON: '/assets/images/double-fiat-gear.svg',
	FIAT_KYC_ICON: '/assets/images/kyc-id-info.svg',
	ONRAMP_SIMPLE_DOLLAR: '/assets/images/simple-fiat-on-ramp-left-slant.svg',
	OFFRAMP_SIMPLE_DOLLAR: '/assets/images/simple-fiat-off-ramp-right-slant.svg',
	MPESA_ICON: '/assets/images/other-fiat-systems.svg',
	FIAT_PLUGIN: '/assets/images/fiat-plugin.svg',
	DOLLAR_GEAR: '/assets/images/single-dollar-gear.svg',
	SWITCH_ASSET_FOR_FEES: '/assets/images/switch-asset-for-fees.svg',
	CLOCK: '/assets/images/clock.svg',
	QR_CODE_SHOW: '/assets/images/mini-qr-code.svg',
	QR_CODE_SCAN: '/assets/images/camera-scan.svg',
	CLOUD_BASIC: '/assets/images/Path 4813.svg',
	CLOUD_CRYPTO: '/assets/images/Path 4815.svg',
	CLOUD_FIAT: '/assets/images/Group 5179.svg',
	CLOUD_BASIC_BACKGROUND: '/assets/images/cloud_fiat_ramp_graphic-01.png',
	CLOUD_CRYPTO_BACKGROUND: '/assets/images/Mask_Group_69.png',
	CLOUD_FIAT_BACKGROUND: '/assets/images/cloud_basic_graphic-01.png',
	FIRE_BALL: '/assets/images/fireball-icon.svg',
	EXCHANGE_LOGO_LIGHT_THEME:
		'/assets/images/default-exchange-logo-light-theme.svg',
	EXCHANGE_ICON: '/assets/images/hex-pattern-icon-black-06.svg',
	MANUAL_PLUGIN_UPGRADE: '/assets/images/manual-plugin-upgrade.svg',
	EXCHANGE_APP_STORE_BACKGROUND_SPLASH:
		'/assets/images/hollaex-exchange-app-store-background-splash-02.png',
	EXCHANGE_APP_STORE_BACKGROUND_SPLASH_2:
		'/assets/images/hollaex-exchange-app-store-background-splash-03.png',
	HOLLAEX_NETWORK_WHITE: '/assets/images/HollaEx network-icon-white-(s)-01.svg',
	INSTALL_THIRD_PARTY_PLUGIN: '/assets/images/install-third-party-plugin.svg',
	OPEN_HOLLAEX_DOC_APP_CREATION:
		'/assets/images/open-hollaex-doc-app-creation-link.svg',
	HOLLAEX_EXCHANGE_STORE_PLUGIN_APPS:
		'/assets/images/hollaex-exchange-store-plugin-apps.svg',
	VERIFIED_BADGE_PLUGIN_APPS: '/assets/images/verified-badge-plugin-apps.svg',
	ONE_TIME_ACTIVATION_PLUGIN: '/assets/images/One-time activation-plugin.svg',
	CREDITS_PLUGIN: '/assets/images/credits-plugin.svg',
	WHITE_USER_KEY: '/assets/images/white-user-key.svg',
	BLUE_ADMIN_KEY: '/assets/images/blue-admin-key.svg',
	REVOKE_KEY: '/assets/images/revoke-key-red-slash.svg',
	SMALL_WHITE_KEY: '/assets/images/small-white-key.svg',
	TRANSPARENT_KEY: '/assets/images/transperent-key.svg',
	GOOGLE_AUTHENTICATOR: '/assets/images/google-auth-icon.svg',
	GOOGLE_PLAY: '/assets/images/google-play.svg',
	APP_STORE: '/assets/images/appstore-apple_logo_black.svg',
	NAV_BAR_ANNOUNCEMENT: '/assets/images/nav-bar-ann-feature.svg',
	POPUP_ANNOUNCEMENT: '/assets/images/pop-up-ann-feature.svg',
	TOP_BAR_ANNOUNCEMENT: '/assets/images/top-bar-ann-feature.svg',
	CHAIN_TRADING: '/assets/images/chain-trading.svg',

	ADMIN_ROLE: '/assets/images/admin.svg',
	SUPERVISOR_ROLE: '/assets/images/SupervisorRole.svg',
	KYC_ROLE: '/assets/images/KYC.svg',
	SUPPORT_COMMUNICATION_ROLE: '/assets/images/Communications.svg',
	SUPPORT_ROLE: '/assets/images/Support.svg',
	OPERATOR_ROLES: '/assets/images/Operator-roles.svg',
	MANAGER_ROLE: '/assets/images/triangle-3d-front.svg',
	AUDITOR_ROLE: '/assets/images/abstract-shape-02.svg',
	ANNOUNCER_ROLE: '/assets/images/flower-atom.svg',

	ADMIN_ROLE_IMAGES: {
		INTERSECTING_CIRCLE: '/assets/images/3-intersecting-circles.svg',
		PENTAGON_ROLE: '/assets/images/3d-pentagon.svg',
		STAR_3d: '/assets/images/3d-star.svg',
		STAR_POINTED: '/assets/images/8-pointed-star.svg',
		ABSTRACT_SHAPE: '/assets/images/abstract-shape.svg',
		ABSTRACT_STAR_LAYERED: '/assets/images/abstract-star-layered.svg',
		ATOM_IMAGE: '/assets/images/atom-01.svg',
		CIRCLE_IMAGE: '/assets/images/circle.svg',
		CLASSIC_CIRCLE: '/assets/images/classic-circle.svg',
		CLASSIC_HEXAGON: '/assets/images/classic-hexagon.svg',
		CLASSIC_STAR: '/assets/images/classic-star.svg',
		CONE_IMAGE: '/assets/images/cone.svg',
		CUBE_TRANSPARENT: '/assets/images/cube-transperent.svg',
		CUBE_IMAGE: '/assets/images/cube.svg',
		CUBE_TOP_DOWN_IMAGE: '/assets/images/cube-top-down.svg',
		CYLINDER_IMAGE: '/assets/images/cylinder.svg',
		DIAMOND_1_IMAGE: '/assets/images/diamond-01.svg',
		DIAMOND_2_IMAGE: '/assets/images/diamond-02.svg',
		DIAMOND_3D_IMAGE: '/assets/images/diamond-3d.svg',
		SIMPLE_FLAT_DIAMOND: '/assets/images/diamond-flat-simple.svg',
		FLAT_DIAMOND: '/assets/images/flat-diamond.svg',
		FLAT_GLOBE_IMAGE: '/assets/images/flat-globe.svg',
		GLOBE_IMAGE: '/assets/images/globe-image.svg',
		HALF_CIRCLE: '/assets/images/half-circle.svg',
		HEXAGON_FLAT_IMAGE: '/assets/images/hexagon-flat.svg',
		HEXAGON_IMAGE: '/assets/images/hexagon.svg',
		MOON_IMAGE: '/assets/images/moon.svg',
		NETWORK_IMAGE: '/assets/images/network.svg',
		OBLIQUE_SQUARE_IMAGE: '/assets/images/oblique-square.svg',
		OVAL_IAMGE: '/assets/images/oval.svg',
		RECTANGLE_IMAGE: '/assets/images/rectangle.svg',
		SPIKE_BUBBLE_IMAGE: '/assets/images/spike-bubble.svg',
		SQUARE_LAYER_IMAGE: '/assets/images/square-2-layers.svg',
		SQUARE_IMAGE: '/assets/images/square.svg',
		STAR_03_IMAGE: '/assets/images/star-03.svg',
		STAR_04_IMAGE: '/assets/images/star-04.svg',
		TRAPIZE_IMAGE: '/assets/images/trapize.svg',
		TRIANGLE_3D_CONE: '/assets/images/triangle-3d-cone.svg',
		TRIANGLE_IMAGE: '/assets/images/triangle.svg',
	},
	MARKET_ICON: '/assets/images/markets.svg',
	DIGITAL_ASSETS_ICON: '/assets/images/digitial-asset.svg',
	FIAT_CONTROLS_ICON: '/assets/images/fiat-controls.svg',
	STAKING_ICON: '/assets/images/staking.svg',
	TEST_ENVIRONMENT_ICON: '/assets/images/test-environment.png',
	MINT_ICON: '/assets/images/mint-asset.svg',
	BURN_ICON: '/assets/images/burn-asset.svg',
	OPERATOR_CONTROL_SEARCH: '/assets/images/admin-search.svg',
	SEARCH_CONTENT: '/assets/images/operator-control-search-content.png',
};

export default icons;
